import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";

// import logo from "./logo.svg";
import "./App.css";
import AppLayout from "./Components/Applayout/Applayout";
// import M from "materialize-css";
import ReactGA from "react-ga";
import axios from "axios";
import mixpanel from "mixpanel-browser";
import { CLARITY_CODE, GOOGLE_ANALYTICS_ID, MIXPANEL_TOKEN, IPIFY_URL, CLARITY_TAG_URL } from "./Components/Constants";
import { prefetchNetworkData } from "./utils/networkDataCache";

ReactGA.initialize(GOOGLE_ANALYTICS_ID);

mixpanel.init(MIXPANEL_TOKEN);

const App = () => {

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = CLARITY_TAG_URL + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_CODE);

  useEffect(() => {
    const clientIP = sessionStorage.getItem("ClientIP");

    if (!clientIP) {
      axios
        .get(IPIFY_URL)
        .then((res) => {
          sessionStorage.setItem("ClientIP", res.data.ip);
        })
        .catch((error) => {
          console.error("Error fetching IP:", error);
        });
    }
    prefetchNetworkData().catch(e => console.warn("Prefetch failed, will retry in component", e));
  }, []);

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        closeOnClick={true}
        pauseOnFocusLoss={false}
        theme="light"
      />
      <AppLayout />
    </div>
  );
};

export default App;
